import { Card, CardContent, Tabs, TabsContent, TabsList, TabsTrigger } from '@ibsys/kit';
import { TrendingDownIcon, TrendingUpIcon } from 'lucide-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import type { StrategistTransition } from '@/entities/strategist';
import { RankingTable } from './RankingTable';

type Props = {
  /** Переходы, повышающие целевой исход */
  rankingUp: StrategistTransition[];
  /** Переходы, понижающие целевой исход */
  rankingDown: StrategistTransition[];
  /** Нажатие на понятие — открыть его карточку */
  onConceptClick: (id: string) => void;
  /** Нажатие на строку — провалиться в диалоги перехода */
  onTransitionClick: (transition: StrategistTransition) => void;
};

/**
 * Блок рейтингов переходов с табами: «Повышают целевой исход» (по умолчанию)
 * и «Понижают целевой исход». В каждом табе — таблица во всю ширину карточки.
 */
export const TransitionsRanking: FC<Props> = ({ rankingUp, rankingDown, onConceptClick, onTransitionClick }) => {
  const { t } = useTranslation('strategist');

  return (
    <Card>
      <CardContent className="p-4">
        <Tabs defaultValue="up" className="flex flex-col gap-3">
          <TabsList>
            <TabsTrigger value="up">
              <span className="inline-flex items-center gap-1.5">
                <TrendingUpIcon className="size-4 text-primary" />
                {t('transitions.ranking.upTitle')}
              </span>
            </TabsTrigger>
            <TabsTrigger value="down">
              <span className="inline-flex items-center gap-1.5">
                <TrendingDownIcon className="size-4 text-destructive" />
                {t('transitions.ranking.downTitle')}
              </span>
            </TabsTrigger>
          </TabsList>
          <TabsContent value="up">
            <RankingTable
              variant="up"
              transitions={rankingUp}
              onConceptClick={onConceptClick}
              onTransitionClick={onTransitionClick}
            />
          </TabsContent>
          <TabsContent value="down">
            <RankingTable
              variant="down"
              transitions={rankingDown}
              onConceptClick={onConceptClick}
              onTransitionClick={onTransitionClick}
            />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};
